import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import OfferingsSection from '../components/OfferingsSection';
import AppFeaturesNura from '../components/AppFeaturesNura';

const OurServicesPage = () => {
  return (
    <div className="min-h-screen bg-black">
      <Navbar />
      <div className="pt-20">
        {/* Introduction Section */}
        <section className="pt-8 pb-2 bg-black">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-2">
              Your everyday city ride, now electric.
            </h1>
          </div>
        </section>
        
        {/* Offerings Section */}
        <OfferingsSection />
      </div>
      <Footer />
    </div>
  );
};

export default OurServicesPage;
